// extracted by mini-css-extract-plugin
module.exports = {"d2xDetailC":"C_ZA_d2xDetailC__yEv6z"};